export const spacing = {
    root: 24,
    regular: 12,
    large: 36,
    list: 8,
}